<script>
import {notificationMethods, personGroupMethods} from "@/state/helpers";

import {required} from "vuelidate/lib/validators";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Toast from '../../../components/widgets/toast';
import appConfig from "@/app.config";


/**
 * Advanced table component
 */
export default {
  page: {
    title: "Plasiyer Grupları",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Toast
  },
  data() {
    return {
      toastAction: '',
      toastMessage: '',
      showToast: false,
      itemsLoaded: false,
      items: [],
      personGroups: [],
      title: "Plasiyer Grupları",
      headerItems: [
        {
          text: "Ana Sayfa",
          href: "/",
        },
        {
          text: "Plasiyer Grupları",
        },
      ],
      addSubmitted: false,
      editSubmitted: false,
      showModal: false,
      editModal: false,
      deleteModal: false,
      noDeleteModal: false,
      addForm: {
        name: "",
        code: "",
        rate: "",
      },
      editForm: {
        name: "",
        code: "",
        rate: "",
      },
      editId: "",
      deleteId: "",
      totalRows: 1,
      page: 1,
      perPage: 10,
      search: '',
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "name",
      sortDesc: false,
      fields: [
        {
          key: "name",
          label: "Ad",
          sortable: true,
        },
        {
          key: "code",
          label: "Kod",
          sortable: false,
        },
        {
          key: "rate",
          label: "Oran",
          sortable: false,
        },
        {
          key: "edit",
          label: "Düzenle",
        },
        {
          key: "delete",
          label: "Sil",
        },
      ],
      pageInput: 1
    };
  },
  validations: {
    addForm: {
      name: {required},
      code: {required},
      rate: {required},
    },
    editForm: {
      name: {required},
      code: {required},
      rate: {required},
    },
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.items.length;
    },
    totalPages() {
      return Math.ceil(this.totalRows / this.perPage);
    },
  },
  watch: {
    page(newPage) {
      this.pageInput = newPage;
      this.getPersonGroups(newPage);
    },
    search(newSearch) {
      if (newSearch.length < 1) {
        if (this.page === 1) {
          this.getPersonGroups();
        } else {
          this.page = 1;
        }
      }
    }
  },
  mounted() {
    this.getPersonGroups();
  },
  methods: {
    ...personGroupMethods,
    ...notificationMethods,
    resetForm() {
      this.addForm = {
        name: null,
        code: null,
        rate: null,
      };
      this.editForm = {
        name: null,
        code: null,
        rate: null,
      };
      this.addSubmitted = false,
          this.editSubmitted = false
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    doSearch() {
      if (this.page === 1) {
        this.getPersonGroups();
      } else {
        this.page = 1;
      }
    },
    getPersonGroups(page = this.page) {
      this.itemsLoaded = false;
      let filter = {}
      if (this.filter) {
        filter.name = this.filter;
      }
      this.fetchPersonGroups({page, limit: this.perPage, search: this.search}).then(res => {
        this.totalRows = res.total;
        // getting category ready for fields
        this.items = res.docs.map(elem => {
          return elem;
        })
        this.itemsLoaded = true;
      })
    },

    handleSubmit() {
      this.addSubmitted = true;
      this.$v.addForm.$touch();
      if (
          this.$v.addForm.$invalid
      ) {
        return;
      } else {

        this.createPersonGroup(this.addForm).then(() => {
          this.toastMessage = "Plasiyer Grup başarıyla eklendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.showModal = false;
          this.getPersonGroups();
          this.addForm.name = "";
          this.addForm.code = "";
          this.addForm.rate = "";
        })
      }
    },

    handleEditSubmit() {
      this.editSubmitted = true;
      this.$v.editForm.$touch();
      if (
          this.$v.editForm.$invalid
      ) {
        return;
      } else {

        this.updatePersonGroup({id: this.editId, data: this.editForm}).then(() => {
          this.toastMessage = "Plasiyer Grup başarıyla düzenlendi!";
          this.toastAction = "success";
          this.showToast = true;
          setTimeout(() => {
            this.showToast = false;
          }, 3000)
          this.editModal = false;
          this.getPersonGroups();
        })
      }
    },
    handleDeleteSubmit() {

      this.deletePersonGroup(this.deleteId).then(() => {
        this.deleteModal = false;
        this.toastMessage = "Plasiyer Grup başarıyla silindi!";
        this.toastAction = "success";
        this.showToast = true;
        setTimeout(() => {
          this.showToast = false;
        }, 3000)
        this.getPersonGroups();
      })

    },

    openEdit(personGroup) {
      this.editForm.name = personGroup.name;
      this.editForm.code = personGroup.code;
      this.editForm.rate = personGroup.rate;
      this.editId = personGroup.id;
      this.editModal = true;
    },
    openDelete(personGroup) {
      this.deleteId = personGroup.id;
      this.deleteModal = true;
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="headerItems"/>
    <Toast :action="this.toastAction" :message="this.toastMessage" v-if="showToast"></Toast>
    <div class="row" v-if="itemsLoaded ">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="d-flex">
                <div
                    id="tickets-table_filter"
                    class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Ara:
                    <b-form-input
                        v-model="search"
                        @keyup.enter="doSearch"
                        type="search"
                        placeholder="ara..."
                        class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
                <button
                    class="btn btn-success ms-auto mb-2"
                    @click="showModal = true; resetForm();"
                >
                  Plasiyer Grup Ekle
                </button>
              </div>
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                  class="datatables"
                  :items="items"
                  :fields="fields"
                  responsive="sm"
              >
                <template v-slot:cell(createdAt)="data">
                  {{ new Date(data.item.createdAt).toDateString() }}
                </template>
                <template v-slot:cell(edit)="data">
                  <button
                      class="btn btn-warning d-flex py-2"
                      @click="openEdit(data.item)"
                  >
                    <i :class="`bx bxs-edit bx-xs`"></i>
                  </button>
                </template>
                <template v-slot:cell(delete)="data">
                  <button
                      class="btn btn-danger d-flex py-2"
                      @click="openDelete(data.item)"
                  >
                    <i :class="`bx bx-trash bx-xs`"></i>
                  </button>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <input
                        :style="{width:'40px', maxWidth:'100%', display:'flex',justifyContent:'center', marginTop:'-3px'}"
                        @keyup.enter="page=pageInput" v-model="pageInput" type="text" class="form-control">
                    <b-pagination
                        v-model="page"
                        :total-rows="totalRows"
                        :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
                <div class="page-info mt-2"> Toplam sayfa sayısı {{ totalPages }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <b-modal v-model="showModal" title="Plasiyer Grup Ekle" hide-footer>
        <form @submit.prevent="handleSubmit">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ad</label>
                <input
                    id="name"
                    type="text"
                    v-model="addForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="code">Kod</label>
                <input
                    id="code"
                    type="text"
                    v-model="addForm.code"
                    class="form-control"
                    placeholder="Kodu giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.code.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.addForm.code.required"
                    class="invalid-feedback"
                >
                  Kod girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="number">Oran</label>
                <input
                    name="number"
                    id="number"
                    type="number"
                    autocomplete="off"
                    v-model="addForm.rate"
                    class="form-control"
                    placeholder="Oran giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.addForm.rate.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && $v.addForm.rate.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.addForm.rate.required">Oran girilmesi gerekli bir alandır.</span>
                </div>
              </div>
            </div>


          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="showModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Plasiyer Grup Ekle
            </b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal v-model="editModal" title="Kullanıcı Düzenle" hide-footer>
        <form @submit.prevent="handleEditSubmit" autocomplete="off">
          <div class="row">
            <div class="col-12">
              <div class="mb-3">
                <label for="name">Ad</label>
                <input
                    id="name"
                    type="text"
                    v-model="editForm.name"
                    class="form-control"
                    placeholder="Ad giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.name.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.name.required"
                    class="invalid-feedback"
                >
                  Ad girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="code">Kod</label>
                <input
                    id="code"
                    type="text"
                    v-model="editForm.code"
                    class="form-control"
                    placeholder="Telefon giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.code.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && !$v.editForm.code.required"
                    class="invalid-feedback"
                >
                  Kod girilmesi gerekli bir alandır.
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="mb-3">
                <label for="rate">Oran</label>
                <input
                    name="rate"
                    id="rate"
                    type="number"
                    autocomplete="off"
                    v-model="editForm.rate"
                    class="form-control"
                    placeholder="Email giriniz"
                    :class="{
                    'is-invalid': addSubmitted && $v.editForm.rate.$error,
                  }"
                />
                <div
                    v-if="addSubmitted && $v.editForm.rate.$error"
                    class="invalid-feedback"
                >
                  <span v-if="!$v.editForm.rate.required">Oran girilmesi gerekli bir alandır.</span>
                </div>
              </div>
            </div>
          </div>
          <div class="text-end mt-3">
            <b-button variant="light" @click="editModal = false"
            >Vazgeç
            </b-button
            >
            <b-button type="submit" variant="success" class="ms-1"
            >Plasiyer Grup Düzenle
            </b-button
            >
          </div>
        </form>
      </b-modal>

      <b-modal
          v-model="deleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>

          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Sil !</h4>
              <p class="text-muted font-size-14 mb-4">
                Bu plasiyer grubu silmek istediğinize emin misiniz? Silinmiş grup geri alamazsınız.
              </p>

              <form @submit.prevent="handleDeleteSubmit">
                <button class="btn btn-danger" type="submit" id="button-addon2">
                  Evet, eminim
                </button>
              </form>
            </div>
          </div>
        </div>
      </b-modal>

      <b-modal
          v-model="noDeleteModal"
          hide-footer
          centered
          header-class="border-0"
      >
        <div class="text-center mb-4">
          <div class="avatar-md mx-auto mb-4">
            <div class="avatar-title bg-light rounded-circle text-danger h1">
              <i class="mdi mdi-delete"></i>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-xl-10">
              <h4 class="text-danger">Silinemez !</h4>
              <p class="text-muted font-size-14 mb-4">
                Oturumunu açtığınız kullanıcıyı silemezsiniz.
              </p>
            </div>
          </div>
        </div>
      </b-modal>

    </div>
    <div class="spinner-wrapper" v-else>
      <b-spinner class="m-5" variant="secondary" role="status"></b-spinner>
    </div>
  </Layout>
</template>
<style scoped>
.pill {
  display: inline-block;
  margin: 10px 10px 0 0;
  padding: 6px 0px 4px 0px;
  background: #2a3042;
  border-radius: 10px;
  font-size: 12px;
  letter-spacing: 1px;
  font-weight: bold;
  color: #fff;
  cursor: pointer;
}

.pill span {
  padding: 6px 12px 4px 12px;
}
</style>
